import {

    FaShoppingBasket,

} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import "./EmptyOrders.css";

function EmptyOrders() {

    const navigate = useNavigate();

    return (

        <div className="empty-orders">

            <FaShoppingBasket />

            <h2>

                No Orders Yet

            </h2>

            <p>

                Looks like you haven't ordered any delicious food yet.

            </p>

            <button

                onClick={() => navigate("/home")}

            >

                Explore Foods

            </button>

        </div>

    );

}

export default EmptyOrders;